import React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FiAlertCircle } from "react-icons/fi";

const Delete = ({ show, close, title, handleDelete, name }) => {
  return (
    <Modal show={show} onHide={close} centered className="deleteStudent">
      <div className="common-modal">
        <Modal.Header className="flex-column align-items-start gap-3 w-auto border-none">
          <div className="text-center">
            <div className="common-modal__icon-wrapper mb-0">
              <FiAlertCircle className="common-modal__lock-icon" />
            </div>
          </div>

          <h6 className="">{title}</h6>
          <p className="common-modal__subtitle mb-0">
            Are you sure you want to delete “{name}”? This action cannot be
            undone.
          </p>
        </Modal.Header>

        <div className="d-flex justify-content-between p-4 pt-0">
          <Button
            variant="outline-secondary"
            className=" w-50  m-2"
            onClick={close}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="w-50 m-2"
            onClick={handleDelete} // Remove the arrow function, it's preventing execution
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default Delete;
